// The house page's "Since you were here" (since.ts): the card at the top of
// the story, things drawn small for its pictures, and where each thing
// stands. A piece indoors seen from outside opens the inside view at its
// floor (?show=<id>), which looks at it and sparkles it.
import * as THREE from 'three';
import { shell } from './ui/shell.js';
import { picture } from './thumbs.js';
import { sinceHere, showOnArrival, spotOf, type Focus, type Spot } from './since.js';

type Opts = {
  scene: THREE.Scene; cam: THREE.PerspectiveCamera; controls: { target: THREE.Vector3; update(): void };
  inside: boolean;
  slug: () => string; target: () => THREE.Vector3; size: () => number;
  // the glide next door (the neighbours, outside only)
  go: ((slug: string) => void) | null;
};

export function sinceHouse(o: Opts) {
  const slug = o.slug();
  const findThing = (id: string) => {
    let f: THREE.Object3D | null = null;
    o.scene.traverse((x) => { if (!f && x.visible && x.userData.thing?.id === id) f = x; });
    return f as THREE.Object3D | null;
  };
  const locate = (f: Focus): Spot | null => {
    // from outside, a piece indoors is behind the walls: no sparkle there, and "Show me" goes in
    if (f.thing) { const x = !o.inside && f.outdoors === false ? null : findThing(f.thing); return x ? spotOf(x) : null; }
    if (f.home && f.home === o.slug()) return { at: o.target().clone(), size: o.size() * 0.45 };
    return null;
  };
  const story = () => {
    const panel = shell().tab('story', 'Story');
    return (panel.querySelector('.pz-scroll') as HTMLElement) || panel;
  };
  const q = new URLSearchParams(location.search);
  const show = q.get('show');
  const base = { scene: o.scene, cam: o.cam, controls: o.controls, locate };
  if (show) {
    // from the card outside: once the floor is drawn, look at it
    setTimeout(() => { showOnArrival(base, { thing: show }); }, 500);
    return;
  }
  void sinceHere({
    ...base,
    place: `@${slug}`, tab: 'story', panel: story,
    thumb: (render) => picture({ kind: 'item', render }),
    act: (f) => {
      if (f.home && f.home !== o.slug()) {
        if (o.go) o.go(f.home); else location.href = `/@${encodeURIComponent(f.home)}`;
        return true;
      }
      if (f.thing && !locate(f)) {
        // indoors, from outside (or on another floor): the inside view, at its floor
        if (!f.outdoors) { location.href = `/@${encodeURIComponent(slug)}?view=inside&floor=${f.level || 0}&show=${encodeURIComponent(f.thing)}`; return true; }
        if (o.inside) { location.href = `/@${encodeURIComponent(slug)}?show=${encodeURIComponent(f.thing)}`; return true; }
      }
      return false;
    },
  });
}
